var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-drawer',{attrs:{"closable":false,"title":_vm.title,"visible":_vm.visible,"width":_vm.width,"destroyOnClose":"","placement":"right"},on:{"close":_vm.close}},[_c('iframe-f-report-view',{attrs:{"src":_vm.iframeSrc}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }